import React from 'react'
import UserLogsRow from './UserLogsRow'
import ReactPaginate from 'react-paginate'
import { KTSVG } from '../../../../_metronic/helpers'
import { useIntl } from 'react-intl'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from '../../../../setup'

const UserLogsTable: React.FC<any> = ({ isLoading, userLogs, listView, itemsPerPage, handlePageClick, pageCount, currentPage, setSorting, getUserLogs, sorting }) => {
  const intl = useIntl()
  const customer: any = useSelector<RootState>(
    ({ device }) => device.customer,
    shallowEqual
  )

  const columns = [
    { field: 'Date', label: 'DEVICE.DATE', sortable: true },
    { field: 'Data', label: 'GENERAL.LABEL.LOG', sortable: true },
  ]

  const handleSort = (field: string) => {
    setSorting((prev: any) => {
      const newOrder = prev.col === field && prev.order === "ASC" ? "DESC" : "ASC";

      getUserLogs(customer, 1, itemsPerPage, field, newOrder);

      return { col: field, order: newOrder };
    });
  };

  return (
    <div className='card-body py-3'>
      {/* begin::Table container */}

      <div className='table-responsive max-height-75vh'>
        {/* begin::Table */}
        <table
          className={`table align-middle table-row-bordered fs-6 gy-5 dataTable no-footer compact
            }`}
        >
          {/* begin::Table head */}
          <thead className='sticky-header'>
            <tr className='text-muted'>
              {columns.map((column: any, i: any) => {
                return (
                  // <th key={i} style={{ width: column.label == 'Actions' ? listView == 'compact' ? '72px' : '358px' : 'auto' }}>
                  <th key={i}>
                    <div
                      onClick={() => column.sortable && handleSort(column.field)}
                      className={column.sortable ? 'sortable cursor-pointer' : ''}
                    >

                      {intl.formatMessage({ id: column.label })}

                      {sorting.col === column.field && (
                        <KTSVG
                          path={sorting.order === "ASC" ? '/media/icons/duotone/Navigation/Angle-up.svg' : '/media/icons/duotone/Navigation/Angle-down.svg'}
                          className='svg-icon-2'
                        />
                      )}
                    </div>
                  </th>
                )
              })}
            </tr>
          </thead>
          {/* end::Table head */}
          {/* begin::Table body */}
          <tbody className='text-gray-600'>
            {userLogs.length > 0 ? (
              <>
                {userLogs &&
                  userLogs.map((log: any, i: number) => {
                    return (
                      <React.Fragment key={i}>
                        <UserLogsRow
                          log={log}
                        />
                      </React.Fragment>
                    )
                  })}
              </>
            ) : (
              <tr>
                <td colSpan={9}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    {intl.formatMessage({ id: 'TOOLTIP.NO_MATCHING_RECORDS_FOUND' })}
                  </div>
                </td>
              </tr>
            )}
          </tbody>
          {/* end::Table body */}
        </table>

        {/* end::Table */}
      </div>

      <div className='row pt-3'>
        <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'></div>
        <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
          {userLogs.length > 0 && (
            <div id='kt_table_users_paginate'>
              {!isLoading &&
                <ReactPaginate
                  className='pagination'
                  breakLabel="..."
                  nextLabel={<>Next &raquo;</>}
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={5}
                  pageCount={pageCount}
                  pageClassName="page-item"
                  previousLinkClassName="page-link"
                  previousClassName="page-item"
                  nextClassName="page-item"
                  nextLinkClassName='page-link'
                  previousLabel={<>&laquo; Previous</>}
                  activeClassName='active'
                  pageLinkClassName='page-link'
                  forcePage={currentPage}
                />
              }
            </div>
          )}
        </div>
      </div>
      {/* end::Table container */}
    </div>
  )
}

export default UserLogsTable
